var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgActionLeaveMsg = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 12.5,
  fill: "#894FE8"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.333 17.334c-.193 0-.373-.04-.506-.1-.474-.247-.807-.587-1.14-1.587-.34-1.04-.98-1.527-1.594-2-.526-.407-1.073-.827-1.546-1.687C10.193 11.32 10 10.62 10 10a3.301 3.301 0 0 1 3.333-3.333A3.301 3.301 0 0 1 16.667 10H18c0-2.62-2.047-4.667-4.667-4.667-2.62 0-4.666 2.047-4.666 4.667 0 .84.253 1.767.713 2.6.607 1.1 1.32 1.654 1.9 2.1.54.414.927.714 1.14 1.367.4 1.213.913 1.893 1.82 2.366A2.666 2.666 0 0 0 18 16h-1.333c0 .733-.6 1.334-1.334 1.334ZM9.093 5.76l-.946-.947A7.31 7.31 0 0 0 6 10c0 2.027.82 3.86 2.147 5.187l.94-.94A6.008 6.008 0 0 1 7.333 10c0-1.66.674-3.16 1.76-4.24ZM11.667 10A1.667 1.667 0 1 0 15 10a1.667 1.667 0 0 0-3.334.001Z",
  fill: "#fff"
})));
export { SvgActionLeaveMsg as ReactComponent };
export default __webpack_public_path__ + "images/action-leave-msg.svg";